import React from 'react';
import styled from 'styled-components';
import SystemInfo from '../../components/admin/SystemInfo';
import SystemLogs from '../../components/admin/SystemLogs';

const SystemSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
`;

const SystemSettings = () => {
  return (
    <SystemSettingsContainer>
      <SystemInfo />
      <SystemLogs />
    </SystemSettingsContainer>
  );
};

export default SystemSettings;